import React from 'react'
import { useParams } from 'react-router-dom'
import {
  DcButton,
  PixelBreadcrumbs,
  PixelCurrency,
  PixelDate,
  PixelPageContainer,
  PixelTable,
  PixelTag,
  PixelTooltip,
  PixelTopBar,
  Section,
  SectionActions,
  SectionContent,
} from 'pixel-base'
import { env } from 'shared/env'
import styled from 'styled-components'

import { getInventoryRequestsDetails } from 'utils/api-routes.util'

const breadcrumbs = [
  {
    name: 'Orders',
    active: false,
    link: '/orders',
  },
  {
    name: 'Inventory Requests',
    active: false,
    link: '/orders/stock-out',
  },
  {
    name: 'Details',
    active: true,
  },
]

const columns = [
  {
    name: 'Image',
    sortable: true,
    selector: (row) => (
      <img src={`${row['image']}`} style={{ maxWidth: '40px' }} />
    ),
  },
  {
    name: 'SKU',
    sortable: true,
    selector: (row) => row.sku || '--',
  },
  {
    name: 'Product Name',
    sortable: true,
    selector: (row) =>
      row['product_name'] && row['product_name'].length > 30
        ? row['product_name'].substring(0, 30) + '...'
        : row['product_name'],
  },
  {
    name: 'Order ID (s)',
    sortable: true,
    selector: (row) => (
      <>
        {row['order_id'] &&
          row['order_id'].length &&
          row['order_id'].length < 15 && <span>{row['order_id']}</span>}
        {row['order_ids'] &&
          row['order_ids'].length &&
          row['order_ids'].length < 15 && <span>{row['order_ids']}</span>}
        {!row['order_id'] && !row['order_ids'] && <span>None</span>}
        {row['order_id'] &&
          row['order_id'].length &&
          row['order_id'].length >= 15 && (
            <PixelTooltip tooltipText={row['order_id']}>Many</PixelTooltip>
          )}
        {row['order_ids'] &&
          row['order_ids'].length &&
          row['order_ids'].length >= 15 && (
            <PixelTooltip tooltipText={row['order_ids']}>Many</PixelTooltip>
          )}
      </>
    ),
  },
  {
    name: 'Inventory ID (s)',
    sortable: true,
    selector: (row) => (
      <>
        {row['inventory_id'] &&
          row['inventory_id'].length &&
          row['inventory_id'].length < 15 && <span>{row['inventory_id']}</span>}
        {row['inventory_ids'] &&
          row['inventory_ids'].length &&
          row['inventory_ids'].length < 15 && (
            <span>{row['inventory_ids']}</span>
          )}
        {!row['inventory_id'] && !row['inventory_ids'] && <span>None</span>}
        {row['inventory_id'] &&
          row['inventory_id'].length &&
          row['inventory_id'].length >= 15 && (
            <PixelTooltip tooltipText={row['inventory_id']}>Many</PixelTooltip>
          )}
        {row['inventory_ids'] &&
          row['inventory_ids'].length &&
          row['inventory_ids'].length >= 15 && (
            <PixelTooltip tooltipText={row['inventory_ids']}>Many</PixelTooltip>
          )}
      </>
    ),
  },
  {
    name: 'Qty. Requested',
    sortable: true,
    selector: (row) => row.qty_requested || '--',
  },
  {
    name: 'Item Price',
    selector: (row) =>
      <PixelCurrency value={row.item_price} currency={'USD'} /> || '--',
  },
  {
    name: 'Total Amount',
    selector: (row) =>
      <PixelCurrency value={row.total_amount} currency={'USD'} /> || '--',
  },
]

const StockOutDetail = () => {
  const params = useParams()
  const [data, setData] = React.useState<any>([])

  const [tableLoading, setTableLoading] = React.useState(false)

  React.useEffect(() => {
    getStockOutDetails()
  }, [])

  const getStockOutDetails = () => {
    setTableLoading(true)
    getInventoryRequestsDetails(params.id).subscribe((res: any) => {
      setData(res.response.data)
      setTableLoading(false)
    })
  }
  const baseURL = env.SERVER_ADDR
  const { token } = JSON.parse(
    localStorage.getItem('user_info') || '{token: null}',
  )
  return (
    <>
      <PixelTopBar>
        <PixelBreadcrumbs data={breadcrumbs} />
        <SectionActions>
          <DcButton
            onClick={() => {
              window.open(
                `${baseURL}api/v2/print/inventory/stock-out/${token}/${params.id}`,
              )
            }}
            variant="outline-secondary"
            size="sm"
          >
            Print
          </DcButton>
          &nbsp; &nbsp;
          <DcButton
            variant="outline-secondary"
            onClick={() => {
              window.open(
                `${baseURL}api/v2/export/inventory/stock-out/${token}/${params.id}`,
              )
            }}
            size="sm"
          >
            Export
          </DcButton>
        </SectionActions>
      </PixelTopBar>
      <PixelPageContainer>
        <DispatchDetailContainer>
          <Left>
            <CourierName>
              <PixelTag className="primary">{}</PixelTag>
            </CourierName>
            <CurrentPlan>
              <PlanSubscription> Total Items Requested: </PlanSubscription>
              <CODAmount>{data?.request?.qty_requested}</CODAmount>
            </CurrentPlan>
            <CurrentPlan>
              <PlanSubscription> Total Items Fulfilled: </PlanSubscription>
              <CODAmount>{data?.request?.qty_provided}</CODAmount>
            </CurrentPlan>
          </Left>
          <Right>
            <PixelDate
              value={data?.request?.created_at}
              format={'pixelStandard'}
            />
          </Right>
        </DispatchDetailContainer>
        <Section>
          <SectionContent>
            <PixelTable
              pagination={false}
              columns={columns}
              progressPending={tableLoading}
              data={data.details}
              highlightOnHover={true}
              pointerOnHover={true}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

const DispatchDetailContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 70%;
  justify-content: space-between;
  background: #ffffffd4;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
`

const Left = styled.div`
  padding-bottom: 10px;
`
const Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin: 26px 20px 0px 0px;
  padding-bottom: 10px;
`
const CurrentPlan = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin: 0px 0px 0px 20px;
  gap: 5px;
`

const CODAmount = styled.span`
  font-weight: 500;
  font-size: 18px;
  color: #344767;
`
const CourierName = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0px 10px 20px;
`

const PlanSubscription = styled.span`
  color: #848aa2;
  font-size: 16px;
  margin-left: 5px;
`

export default StockOutDetail
